// O portal nao usa Service Worker, mas deploys antigos podem ter registrado
// um (ex: vite-plugin-pwa). SWs zumbis interceptam requests e causam
// "carregando pra sempre" ate o user dar Ctrl+Shift+R.
// Este modulo roda no boot e remove qualquer SW + caches residuais.
export async function cleanupZombieServiceWorkers() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return
  try {
    const regs = await navigator.serviceWorker.getRegistrations()
    if (regs.length > 0) {
      await Promise.all(regs.map((r) => r.unregister()))
      console.info('[boot] Desregistrou', regs.length, 'service worker(s) zumbi.')
    }
    if (typeof caches !== 'undefined') {
      const keys = await caches.keys()
      if (keys.length > 0) {
        await Promise.all(keys.map((k) => caches.delete(k)))
        console.info('[boot] Limpou', keys.length, 'cache(s) residual(is).')
      }
    }
  } catch (e) {
    console.warn('[boot] Falha ao limpar service workers:', e)
  }
}
